export default __webpack_public_path__ + "static/media/vietnamese.887bbb0e.svg";